export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverRoleEnum_AllergyDoctor": "Lægen",
	"CaregiverRoleEnum_Dentist": "Tandlægen",
	"CaregiverRoleEnum_Dermatologist": "Hudlægen",
	"CaregiverRoleEnum_Doctor": "Familielægen",
	"CaregiverRoleEnum_Midwife": "Jordemoderen",
	"CaregiverRoleEnum_Nurse": "Sygeplejersken",
	"CaregiverRoleEnum_Physiotherapist": "Fysioterapeuten",
	"CaregiverRoleEnum_Psychologist": "Psykologen",
	"CaregiverRoleEnum_Rheumatologist": "Reumatologen",
	"CaregiverRoleEnum_SundVaegtDoctor": "SundVægt-lægen",
	"CaregiverRoleEnum_SundVaegtNurse": "SundVægt-sygeplejersken",
	"CaregiverRoleEnum_Dietitian": "Diætisten",
	"CaregiverRoleEnum_AcneDermatologist": "Hudlægen",
	"CaregiverRoleEnum_Veterinarian": "Dyrlægen",
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": "Læge",
	"CaregiverRoleEnum_Dentist_Indefinite": "Tandlæge",
	"CaregiverRoleEnum_Dermatologist_Indefinite": "Hudlæge",
	"CaregiverRoleEnum_Doctor_Indefinite": "Familielæge",
	"CaregiverRoleEnum_Midwife_Indefinite": "Jordemoder",
	"CaregiverRoleEnum_Nurse_Indefinite": "Sygeplejerske",
	"CaregiverRoleEnum_Physiotherapist_Indefinite": "Fysioterapeut",
	"CaregiverRoleEnum_Psychologist_Indefinite": "Psykolog",
	"CaregiverRoleEnum_Rheumatologist_Indefinite": "Reumatolog",
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": "SundVægt-læge",
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": "SundVægt-sygeplejerske",
	"CaregiverRoleEnum_Dietitian_Indefinite": "Diætist",
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": "Hudlæge",
	"CaregiverRoleEnum_Veterinarian_Indefinite": "Dyrlæge",
	"CaregiverSpecialization_ClinicalPsychologist": "Klinisk psykolog",
	"CaregiverSpecialization_FamilyTherapy": "Familieterapi",
	"CaregiverSpecialization_SundVaegt": "SundVægt",
	"CaregiverSpecialization_Pediatric": "Pædiatri",
	"ConsultationPaymentProviderEnum_ApplePay": "App Store",
	"ConsultationPaymentProviderEnum_Company": "Virksomhed",
	"ConsultationPaymentProviderEnum_Coupon": "Kupon",
	"ConsultationPaymentProviderEnum_DIBS": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_ePay": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_GoogleWallet": "Google Play",
	"ConsultationPaymentProviderEnum_GracePeriod": "Gratis svar",
	"ConsultationPaymentProviderEnum_ReepayCheckout": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_Repay": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_Subscription": "Abonnement",
	"ConsultationPaymentProviderEnum_PriceOverride": "-",
	"ConsultationCategoryFilterEnum_Video": "Video",
	"ConsultationCategoryFilterEnum_Text": "Tekst",
	"ConsultationTypeEnum_AllergyCheckVideo": "Allergitjek",
	"ConsultationTypeEnum_DentistMessage": "Tekstkonsultation - tandlæge",
	"ConsultationTypeEnum_DentistVideo": "Videokonsultation - tandlæge",
	"ConsultationTypeEnum_DermatologistMessage": "Tekstkonsultation - hudlæge",
	"ConsultationTypeEnum_DermatologistVideo": "Videokonsultation - hudlæge",
	"ConsultationTypeEnum_Message": "Tekstkonsultation - læge",
	"ConsultationTypeEnum_MidwifeMessage": "Tekstkonsultation - jordemoder",
	"ConsultationTypeEnum_MidwifeVideo": "Videokonsultation - jordemoder",
	"ConsultationTypeEnum_NurseMessage": "Tekstkonsultation - sundhedsplejerske",
	"ConsultationTypeEnum_NurseVideo": "Videokonsultation - sundhedsplejerske",
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": "Videokonsultation - fysioterapeut opstart",
	"ConsultationTypeEnum_PhysiotherapistMessage": "Tekstkonsultation - fysioterapeut",
	"ConsultationTypeEnum_Prescription": "Receptfornyelse",
	"ConsultationTypeEnum_PsychologistVideo": "Videokonsultation - psykolog",
	"ConsultationTypeEnum_PsychologistCrisisVideo": "Videokonsultation - krisepsykolog",
	"ConsultationTypeEnum_PsychologistFamilyTherapyVideo": "Familieterapi",
	"ConsultationTypeEnum_RheumatologistVideo": "Videokonsultation - reumatolog",
	"ConsultationTypeEnum_SundVaegtStartupMessage": "SundVægt opstart",
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt kontrol",
	"ConsultationTypeEnum_Video": "Videokonsultation - læge",
	"ConsultationTypeEnum_DietitianStartupVideo": "Videokonsultation - diætist opstart",
	"PlanInterval_Day": "Daglig",
	"PlanInterval_Month": "Månedlig",
	"PlanInterval_Week": "Ugentlig",
	"PlanInterval_Year": "Årlig",
	"ServiceTypeEnum_AllergyCheck": "Allergitjek: Videokonsultation",
	"ServiceTypeEnum_DermatologistMessage": "Hudlæge: Tekstkonsultation",
	"ServiceTypeEnum_DermatologistMessageReply": "Hudlæge: Svar på tekstkonsultation",
	"ServiceTypeEnum_DermatologistVideo": "Hudlæge: Videokonsultation",
	"ServiceTypeEnum_Message": "Læge: Tekstkonsultation",
	"ServiceTypeEnum_MessageReply": "Læge: Svar på tekstkonsultation",
	"ServiceTypeEnum_PhysiotherapistStartupVideo": "Fysioterapeut: Videokonsultation opstart",
	"ServiceTypeEnum_PhysiotherapistMessage": "Fysioterapeut: Tekstkonsultation",
	"ServiceTypeEnum_PhysiotherapistMessageReply": "Fysioterapeut: Svar på tekstkonsultation",
	"ServiceTypeEnum_Prescription": "Læge: Receptfornyelse",
	"ServiceTypeEnum_PsychologistVideo": "Psykolog: Videokonsultation",
	"ServiceTypeEnum_PsychologistCrisisVideo": "Krisepsykolog: Videokonsultation",
	"ServiceTypeEnum_PsychologistFamilyTherapyVideo": "Familieterapeut: Videokonsultation",
	"ServiceTypeEnum_RheumatologistVideo": "Reumatolog: Videokonsultation",
	"ServiceTypeEnum_SundVaegtStartupMessage": "SundVægt opstart",
	"ServiceTypeEnum_VideoConsultation": "Læge: Videokonsultation",
	"ServiceTypeEnum_AllergyCheckVideo": "Allergitjek",
	"ServiceTypeEnum_DietitianStartupVideo": "Diætist: Videokonsultation opstart",
	"UserTypeEnum_Admin": "Administrator",
	"UserTypeEnum_Doctor": "Behandler",
	"UserTypeEnum_Patient": "Patient",
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt-læge: Videokonsultation",
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt-læge: Videokonsultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt-sygeplejerske: Videokontrol",
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt-sygeplejerske: Tekstkonsultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt-sygeplejerske: Tekstkonsultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": "SundVægt-sygeplejerske: Svar på tekstkonsultation",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": "SundVægt spørgeskema: Svar",
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt kontrol",
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt-sygeplejerske: Videokonsultation",
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt spørgeskema",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt spørgeskema",
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": "Videokonsultation - fysioterapeut",
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": "Fysioterapeut: Videokonsultation",
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": "Fysioterapeut spørgeskema",
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": "Fysioterapeut: spørgeskema",
	"ServiceTypeEnum_SundVaegtStartupMessageReply": "SundVægt opstart: Svar",
	"SubscriptionStatusEnum_Active": "Aktiv",
	"SubscriptionStatusEnum_Canceled": "Afmeldt",
	"SubscriptionStatusEnum_Expired": "Udløbet",
	"SubscriptionStatusEnum_PastDue": "Forfalden",
	"SubscriptionStatusEnum_Trialing": "Gratis prøve",
	"SubscriptionStatusEnum_Unknown": "Ukendt",
	"ConsultationTypeEnum_DietitianCheckupVideo": "Videokonsultation - diætist opfølgning",
	"ServiceTypeEnum_DietitianCheckupVideo": "Diætist: Videokonsultation opfølgning",
	"ConsultationTypeEnum_DietitianUploadAttachmentMessage": "Send filer til diætisten",
	"ServiceTypeEnum_DietitianUploadAttachmentMessage": "Diætist: Upload bilag",
	"ServiceTypeEnum_DietitianVideo": "Diætist: Videokonsultation",
	"AllergyCheckVideo": "Allergitjek",
	"ConsultationTypeEnum_AllergyCheck": "Allergitjek",
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": "Opstart af personligt sundhedsprogram",
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": "Opstart af personligt sundhedsprogram",
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": "Akneforløb opstart",
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": "Akneforløb video opstart",
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": "Akneforløb video opfølgning",
	"ServiceTypeEnum_AcneProgrammeStartupMessage": "Akneforløb opstart",
	"ServiceTypeEnum_AcneProgrammeStartupVideo": "Akneforløb video opstart",
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": "Akneforløb video opfølgning",
	"ConsultationTypeEnum_AcneDermatologistMessage": "Tekstkonsultation - hudlæge",
	"ServiceTypeEnum_AcneDermatologistMessage": "Hudlæge: Tekstkonsultation",
	"ServiceTypeEnum_AcneDermatologistMessageReply": "Hudlæge: Svar på tekstkonsultation",
	"ServiceTypeEnum_VeterinarianVideo": "Dyrlæge: Videokonsultation",
	"ConsultationPaymentProviderEnum_Free": "Gratis",
	"ConsultationPaymentProviderEnum_CreatedByCaregiver": "Oprettet af behandler",
	"ConsultationTypeEnum_VeterinarianVideo": "Videokonsultation – dyrlæge",
	"PetSex_Female": "Hun",
	"PetSex_FemaleSterilized": "Steriliseret hun",
	"PetSex_Male": "Han",
	"PetSex_MaleNeutered": "Kastreret han",
	"PetSex_Unknown": "Ukendt",
	"PetType_Dog": "Hund",
	"PetType_Cat": "Kat",
	"PetType_Rabbit": "Kanin",
	"PetType_Rodent": "Gnaver",
	"ReferralOptionEnum_SpecialistsAndPrivateHospitals": "Speciallæger og private sygehuse",
	"ReferralOptionEnum_Physiotherapy": "Fysioterapi",
	"ReferralOptionEnum_Psychologist": "Psykolog",
	"VetConsultationReasonEnum_Gastrointestinal": "Gastrointestinal",
	"VetConsultationReasonEnum_SkinCoatEars": "Hud, pels og ører (herunder også sår og analkirtler)",
	"VetConsultationReasonEnum_Poisoning": "Forgiftning",
	"VetConsultationReasonEnum_Eyes": "Øjne",
	"VetConsultationReasonEnum_UrinaryTract": "Urinveje",
	"VetConsultationReasonEnum_Lameness": "Halthed",
	"VetConsultationReasonEnum_RespiratoryTract": "Luftveje",
	"VetConsultationReasonEnum_OralCavity": "Mundhule og tænder",
	"VetConsultationReasonEnum_Pain": "Smerter/feber/nedstemthed",
	"VetConsultationReasonEnum_Claws": "Kløer",
	"VetConsultationReasonEnum_GenitalsMammaryGlands": "Genitalier og mammae",
	"VetConsultationReasonEnum_ReproductionCycle": "Reproduktion og cyklus",
	"VetConsultationReasonEnum_Behaviour": "Adfærd",
	"VetConsultationReasonEnum_Prescription": "Recept",
	"VetConsultationReasonEnum_OtherReason": "Andet",
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": "Rådgivet til behandling i hjemmet (Herunder også cases der ikke kræver behandling)",
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": "Henvist inden for almindelig åbningstid",
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": "Henvist uden for almindelig åbningstid",
	"PhysioConsultationOutcomeEnum_ConservativeApproachPatientContinuesAlone": "Konservativ tilgang, pt arbejder videre på egen hånd",
	"PhysioConsultationOutcomeEnum_OfferedFollowUpConsultation": "Tilbudt opfølgende konsultation (konservativ tilgang)",
	"PhysioConsultationOutcomeEnum_ReturnedToVisitationForPhysicalTreatment": "Sendt retur til visitation mhp fysisk behandling",
	"PhysioConsultationOutcomeEnum_ReturnedToOwnDoctor": "Sendt retur til egen læge",
	"PhysioConsultationOutcomeEnum_NoShow": "Udeblivelse",
	"ConsultationTypeEnum_DynamicCodeVideo": "Videokonsultation - Dynamic Code",
	"ServiceTypeEnum_DynamicCodeVideo": "Videokonsultation - Dynamic Code",
	"ServiceTypeEnum_NurseVideo": "Sundhedsplejerske: video",
	"ServiceTypeEnum_MidwifeVideo": "Jordemoder: video",
	"ServiceTypeEnum_NurseMessage": "Sundhedsplejerske: Tekstkonsultation",
	"ServiceTypeEnum_NurseMessageReply": "Sundhedsplejerske: Svar på tekstkonsultation",
	"ServiceTypeEnum_MidwifeMessage": "Jordemoder: Tekstkonsultation",
	"ServiceTypeEnum_MidwifeMessageReply": "Jordemoder: Svar på tekstkonsultation",
	"ConsultationTypeEnum_VeterinarianMessage": "Tekstkonsultation - dyrlæge",
	"ServiceTypeEnum_VeterinarianMessage": "Dyrlæge: Tekstkonsultation",
	"ServiceTypeEnum_VeterinarianMessageReply": "Dyrlæge: Svar på tekstkonsultation",
	"VetConsultationOutcomeEnum_RequestedMoreInformation": "Anmodet om mere information (eller book en ny videokonsultation)",
	"ConsultationTypeEnum_PracticeManagerMessage": "Anden henvendelse",
	"CaregiverRoleEnum_PracticeManager_Indefinite": "Praksismanager",
	"ServiceTypeEnum_PracticeManagerMessage": "Anden henvendelse",
	"CaregiverRoleEnum_PracticeManager": "Praksismanageren",
	"ConsultationTypeEnum_PsychologistMessage": "Psykolog: Tekstkonsultation",
	"ServiceTypeEnum_PsychologistMessage": "Psykolog: Tekstkonsultation",
	"SubscriptionStatusEnum_OnHold": "På pause",
	"ReferralType_Physiotherapy": "Fysioterapihenvisning",
	"ReferralType_Hospital": "Sygehushenvisning",
	"ReferralType_Psychologist": "Psykologhenvisning",
	"ReferralType_Specialist": "Specialisthenvisning",
	"SpecialistVisitationOptionsEnum_InternMedicine": "intern Medicine",
	"SpecialistReferralCode_TreatmentAndInvestigation": "Udredning og behandling",
	"SpecialistReferralCode_Radiology": "Radiologi",
	"SpecialistReferralCode_ContinuedTreatment": "Fortsat behandling",
	"SpecialistReferralCode_Visit": "Besøg",
	"SpecialistReferralCode_SingleConsultationAssessment": "Vurdering ved enkeltstående konsultation",
	"HospitalCallPriority_Urgent": "akut",
	"HospitalCallPriority_Elective": "elektiv",
	"HospitalStatus_Outpatient": "ambulant",
	"HospitalStatus_Admission": "indlæggelse",
	"HospitalTransport_None": "ingen",
	"HospitalTransport_Seated": "siddende",
	"HospitalTransport_Lying": "liggende",
	"PsychologyDiagnosis_RobberyViolenceOrRapeVictim": "Røveri-, volds – eller voldtægtsoffer",
	"PsychologyDiagnosis_TrafficOrAccidentVictim": "Trafik eller ulykkesoffer",
	"PsychologyDiagnosis_RelativesOfSeriouslyMentallyIllPersons": "Pårørende til alvorligt psykisk syge personer",
	"PsychologyDiagnosis_PersonsAffectedBySeriousDisablingDisease": "Personer ramt af alvorligt invaliderende sygdom",
	"PsychologyDiagnosis_RelativesOfPersonsAffectedBySeriousDisablingDisease": "Pårørende til personer ramt af alvorligt invaliderende sygdom",
	"PsychologyDiagnosis_RelativesInCaseOfDeath": "Pårørende ved dødsfald",
	"PsychologyDiagnosis_PersonsWhoHaveAttemptedSuicide": "Personer der har forsøgt selvmord",
	"PsychologyDiagnosis_WomenUndergoingAbortionAfter12WeeksOfPregnancy": "Kvinder, der får foretaget provokeret abort efter 12. graviditetsuge. Kan ydes forud, når anmodning er fremsendt til abortsamrådet.",
	"PsychologyDiagnosis_PersonsUnder18WhoHaveBeenVictimsOfIncestOrOtherSexualAbuse": "Personer der inden det fyldte 18. år har været ofre for incest eller andre seksuelle overgreb.",
	"PsychologyDiagnosis_PersonsWithMildToModerateDepressionAfterPsychometricTest": "Personer med let til moderat depression, efter udført psykometrisk test, (fra 25 år)",
	"PsychologyDiagnosis_PersonsWithMildToModerateAnxietyIncludingMildToModerateOCD": "Personer med let til moderat angst, herunder let til moderat OCD, (fra 25 år)",
	"PsychologyDiagnosis_DeviationFrom6Months": "Fravigelse af 6 mdrs. fristen (kort begrundelse)",
	"ServiceTypeEnum_NnStartupVideo": "SundVægtSammen: Opstartsvideo",
	"ServiceTypeEnum_NnNurseCheckupVideo": "SundVægtSammen: Opfølgende video med SundVægt-sygeplejerske",
	"ServiceTypeEnum_NnDietitianCheckupVideo": "SundVægtSammen: Opfølgende video med diætist",
	"ServiceTypeEnum_NnDoctorMessage": "SundVægtSammen: Besked til SundVægt læge",
	"ServiceTypeEnum_NnDoctorMessageReply": "SundVægtSammen: Svar fra SundVægt læge",
	"ServiceTypeEnum_NnScreeningQuestionnaireMessage": "SundVægtSammen: Screening spørgeskema",
	"ServiceTypeEnum_NnOnboardingQuestionnaireMessage": "SundVægtSammen: Onboarding spørgeskema",
	"ServiceTypeEnum_NnCheckupQuestionnaireMessage": "SundVægtSammen: Opfølgende spørgeskema",
	"ServiceTypeEnum_NnExitQuestionnaireMessage": "SundVægtSammen: Afsluttende spørgeskema",
	"ServiceTypeEnum_SundVaegtExitQuestionnaireMessage": "SundVægt: Afsluttende spørgeskema",
	"ConsultationTypeEnum_NnStartupVideo": "SundVægtSammen opstartsvideo",
	"ConsultationTypeEnum_NnNurseCheckupVideo": "SundVægtSammen opfølgende video med sygeplejerske",
	"ConsultationTypeEnum_NnDietitianCheckupVideo": "SundVægtSammen opfølgende video med diætist",
	"ConsultationTypeEnum_NnDoctorMessage": "SundVægtSammen besked til læge",
	"ConsultationTypeEnum_NnScreeningQuestionnaireMessage": "SundVægtSammen screening spørgeskema",
	"ConsultationTypeEnum_NnOnboardingQuestionnaireMessage": "SundVægtSammen onboarding spørgeskema",
	"ConsultationTypeEnum_NnCheckupQuestionnaireMessage": "SundVægtSammen opfølgende spørgeskema",
	"ConsultationTypeEnum_NnExitQuestionnaireMessage": "SundVægtSammen afsluttende spørgeskema",
	"ConsultationTypeEnum_SundVaegtExitQuestionnaireMessage": "SundVægt afsluttende spørgeskema",
	"ConsultationTypeEnum_SundVaegtFeedbackQuestionnaireMessage": "SundVægt feedback spørgeskema",
	"ServiceTypeEnum_SundVaegtFeedbackQuestionnaireMessage": "SundVægt: feedback spørgeskema",
	"HospitalPriorityOptionsEnum_Urgent": "Akut",
	"HospitalPriorityOptionsEnum_Elective": "Elektiv",
	"HospitalTransportOptionsEnum_None": "Ingen",
	"HospitalTransportOptionsEnum_Seated": "Siddende",
	"HospitalTransportOptionsEnum_Lying": "Liggende",
	"HospitalStatusOptionsEnum_Admission": "Indlæggelse",
	"HospitalStatusOptionsEnum_Outpatient": "Ambulant",
	"ConsultationPaymentProviderEnum_HouseholdAccess": "Husstandsadgang",
	"ServiceTypeEnum_MenopauseStartupVideo": "SundOvergang: opstartskonsultation med læge",
	"ServiceTypeEnum_MenopauseNurseCheckupVideo": "SundOvergang: opfølgende video med sygeplejerske",
	"ServiceTypeEnum_MenopauseNurseMessage": "SundOvergang: tekstkonsultation",
	"ServiceTypeEnum_MenopauseNurseMessageReply": "SundOvergang: svar på tekstkonsultation",
	"ConsultationTypeEnum_MenopauseStartupVideo": "SundOvergang: opstartskonsultation med læge",
	"ConsultationTypeEnum_MenopauseNurseCheckupVideo": "SundOvergang: opfølgende video med sygeplejerske",
	"ConsultationTypeEnum_MenopauseNurseMessage": "SundOvergang: tekstkonsultation",
	"ConsultationTypeEnum_MenopauseOffboardingVideo": "SundOvergang: afsluttende konsultation med læge",
	"ServiceTypeEnum_MenopauseOffboardingVideo": "SundOvergang: afsluttende konsultation med læge",
	"CaregiverRoleEnum_Gynecologist": "Gynækologen",
	"CaregiverRoleEnum_MenopauseDoctor": "SundOvergang-lægen",
	"CaregiverSpecialization_Menopause": "Overgangsalder",
	"CaregiverRoleEnum_Gynecologist_Indefinite": "Gynækolog",
	"CaregiverRoleEnum_MenopauseDoctor_Indefinite": "SundOvergang-læge",
	"ConsultationTypeEnum_DietitianMessage": "Tekstkonsultation - diætist",
	"ServiceTypeEnum_DietitianMessage": "Diætist: Tekstkonsultation",
	"ServiceTypeEnum_DietitianMessageReply": "Diætist: Svar på tekstkonsultation",
	"EpicrisisDocumentType_DischargeLetter": "Udskrivningsepikrise",
	"EpicrisisDocumentType_OutPatientDischargeLetter": "Ambulantepikrise",
	"EpicrisisDocumentType_CasualtyWardLetter": "Skadestueepikrise",
	"EpicrisisDocumentType_RadiologyReport": "Billeddiagnostisk epikrise ",
	"EpicrisisDocumentType_PrivateSpecialistLetter": "Speciallægeepikrise",
	"ConsultationTypeEnum_MenopauseDietitianVideo": "SundOvergang: videokonsultation med diætist",
	"ServiceTypeEnum_MenopauseDietitianVideo": "SundOvergang: videokonsultation med diætist",
	"ServiceTypeEnum_MenopauseHalfwayVideo": "SundOvergang: midtvejskonsultation med læge",
	"ConsultationTypeEnum_MenopauseHalfwayVideo": "SundOvergang: midtvejskonsultation med læge",
	"AuditProblemCategory_IncorrectDiagnosis": "Forkert diagnose",
	"AuditProblemCategory_InsufficientTreatment": "Utilstrækkelig behandling",
	"AuditProblemCategory_MedicationError": "Medicineringsfejl",
	"AuditProblemCategory_DocumentationError": "Dokumentationsfejl",
	"AuditProblemCategory_CommunicationIssue": "Kommunikationsproblem",
	"AuditProblemCategory_OtherIssue": "Andet",
	"PhysioConsultationOutcomeEnum_OfferedVideoConsultation": "Tilbudt videokonsultation",
	"PhysioConsultationOutcomeEnum_NeedMoreInformation": "Brug for mere information",
	"CaregiverRoleEnum_Doctor_Plural": "Familielæger",
	"CaregiverRoleEnum_Nurse_Plural": "Sygeplejersker",
	"CaregiverRoleEnum_Dentist_Plural": "Tandlæger",
	"CaregiverRoleEnum_Midwife_Plural": "Jordemødre",
	"CaregiverRoleEnum_Dermatologist_Plural": "Hudlæger",
	"CaregiverRoleEnum_Rheumatologist_Plural": "Reumatologer",
	"CaregiverRoleEnum_Physiotherapist_Plural": "Fysioterapeuter",
	"CaregiverRoleEnum_Psychologist_Plural": "Psykologer",
	"CaregiverRoleEnum_AllergyDoctor_Plural": "Læger",
	"CaregiverRoleEnum_SundVaegtDoctor_Plural": "SundVægt-læger",
	"CaregiverRoleEnum_SundVaegtNurse_Plural": "SundVægt-sygeplejersker",
	"CaregiverRoleEnum_Dietitian_Plural": "Diætister",
	"CaregiverRoleEnum_AcneDermatologist_Plural": "Hudlæger",
	"CaregiverRoleEnum_Veterinarian_Plural": "Dyrlæger",
	"CaregiverRoleEnum_PracticeManager_Plural": "Praksismanagere",
	"CaregiverRoleEnum_Gynecologist_Plural": "Gynækologer",
	"CaregiverRoleEnum_MenopauseDoctor_Plural": "SundOvergang-læger"
}